const $_result = {
    BEYOND: 'BEYOND',//need upload
    LATEST: 'LATEST',//synced
    OLD: 'OLD',//need download
    EMPTY: 'EMPTY',//no configuration
    REJECT: 'REJECT'
}
export default {
    data() {
        return {
            checkLoading: false,
            uploading: false,
        }
    },
    methods: {
        $_check(identifyCode, key, lastModifyTime) {
            if (!this.handleConcurrent(identifyCode, key)) {
                return new Promise(() => {
                });
            }
            return new Promise((resolve) => {
                this.checkLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ASSISTANT_URL + "/jscConfiguration/sync/get",
                    data: {
                        identifyCode: identifyCode,
                        key: key,
                        lastModifyTime: lastModifyTime
                    },
                    commonErrorHandle: false,
                    consoleLog: false
                }).then(response => {
                    if (response && response.data) {
                        let result = response.data.checkResult;
                        let temp = {};
                        if (result === $_result.BEYOND) {
                            temp.isBeyond = true;
                        } else if (result === $_result.OLD) {
                            temp.hasNew = true;
                            temp.configuration = response.data.configuration;
                        } else if (result === $_result.EMPTY) {
                            temp.noRemoteVersion = true;
                        } else if (result === $_result.LATEST) {
                            temp.latest = true;
                        }
                        resolve(temp);
                    }
                }).finally(() => {
                    this.checkLoading = false;
                    this.handleConcurrentClear(identifyCode, key);
                });
            });
        },
        $_upload(form = {}) {
            return new Promise((resolve, reject) => {
                this.uploading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_ASSISTANT_URL + "/jscConfiguration/upload",
                    data: form,
                    commonErrorHandle: false,
                    consoleLog: false
                }).then(() => resolve())
                    .catch(e => reject(e))
                    .finally(() => this.uploading = false);
            })
        },
        handleConcurrent(code, key) {
            let keySet = window.jscVersionCheckingSet;
            if (keySet === undefined || keySet == null) {
                window.jscVersionCheckingSet = new Set();
                keySet = window.jscVersionCheckingSet;
            }
            let idKey = code + ':#:' + key;
            if (keySet.has(idKey)) {
                return false;
            } else {
                keySet.add(idKey);
                return true;
            }
        },
        handleConcurrentClear(code, key) {
            let idKey = code + ':#:' + key;
            let keySet = window.jscVersionCheckingSet;
            if (keySet !== undefined && keySet != null) {
                keySet.delete(idKey);
            }
        },
    }
}
